<template>
  <div class="py-0 px-3 request-alert-container">
    <v-alert
      v-model="show"
      :type="type"
      :icon="icon"
      border="top"
      dismissible
      colored-border
      prominent
      dense
      elevation="2"
      transition="scale-transition"
    >
      <v-row>
        <span>{{ message }}</span>
        <span class="ml-2" v-show="code !== null && code !== ''">{{
          code
        }}</span>
      </v-row>
      <div class="error-container">
        <v-row no-gutters dense v-for="(error, index) in errors" :key="index">
          <span class="font-weight-bold">{{ error }}</span>
        </v-row>
      </div>
    </v-alert>
  </div>
</template>

<script>
import { privateInstance } from "@/api/configs";
export default {
  name: "RequestAlert",
  data() {
    return {
      message: "",
      show: false,
      code: "",
      errors: [],
      type: "info",
      timeout: null,
      icon: "fa-check"
    };
  },
  created() {
    privateInstance.interceptors.response.use(
      response => {
        if (
          response.config.method === "put" ||
          response.config.method === "post"
        ) {
          this.type = "success";
          this.code = null;
          this.icon = "fa-check";
          this.errors = [];
          this.message = "Opération effectuée avec succès";
          this.show = true;
          this.timer();
        }
        return response;
      },
      error => {
        if (error.message === "requestCancel") return Promise.reject(error);
        if (process.env.NODE_ENV !== "production") {
          console.error(error.response);
        }
        this.type = "error";
        this.message = "Une erreur est survenue lors du traitement.";
        this.icon = "fa-exclamation";
        if (error.response) {
          this.code = ` ( Code: ${error.response.status} )`;
          this.errors = [];
          if (error.response.data) {
            if (
              error.response.data.data &&
              typeof error.response.data.data === "object"
            ) {
              for (let key in error.response.data.data) {
                if (Array.isArray(error.response.data.data[key])) {
                  error.response.data.data[key].forEach(errorMessage => {
                    this.errors.push(`${key}: ${errorMessage}`);
                  });
                } else {
                  this.errors.push(`${key}: ${error.response.data.data[key]}`);
                }
              }
            } else if (typeof error.response.data === "object") {
              for (let key in error.response.data) {
                if (Array.isArray(error.response.data[key])) {
                  error.response.data[key].forEach(errorMessage => {
                    this.errors.push(`${key}: ${errorMessage}`);
                  });
                } else {
                  this.errors.push(`${key}: ${error.response.data[key]}`);
                }
              }
            } else {
              if (error.response.status !== 500) {
                this.errors.push(`${error.response.data}`);
              }
            }
          }
        }

        this.show = true;
        this.timer();
        return error.response
          ? Promise.reject(error.response)
          : Promise.reject(error);
      }
    );
  },
  methods: {
    timer() {
      if (this.timeout !== null) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => (this.show = false), 3000);
    }
  }
};
</script>

<style lang="scss" scoped>
.request-alert-container {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 999;
  width: 100%;
}
.error-container {
  width: 86vw;
  max-height: 10rem;
  overflow-y: auto;
}
</style>
